module.exports = __webpack_public_path__ + "static/img/MINI.8a3fc23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/MINI.png
// module id = JB3G
// module chunks = 1